<template>
  <div class="container">
  <van-row class="content" type="flex" justify="space-around">
    <van-col class="con-left" span="18">
      <cell v-for="item in list" :key="item.bbsId" :item="item"></cell>
      <van-pagination 
        v-model="pageNum" 
        :total-items="totalItems" 
        :items-per-page="itemsPerPage" 
        :show-page-size="5"
        force-ellipses
        @change="pageChanged"
      >
        <template #prev-text>
          <van-icon name="arrow-left" />
        </template>
        <template #next-text>
          <van-icon name="arrow" />
        </template>
        <template #page="{ text }">{{ text }}</template>
      </van-pagination>
    </van-col>
    <van-col class="con-right" span="6">
      <pc-class class="class" :classes="classes" @clickClass="clickClass"></pc-class>
      <pc-label class="label" :classes="classes" :labels="labels" @clickLabel="clickLabel" @clickTab="clickTab"></pc-label>
    </van-col>
  </van-row>
  </div>
</template>

<script>
import cell from './components/pc_cell.vue'
import { getArticleList, getLabelList } from 'api'
import PcClass from './components/pc_class.vue'
import PcLabel from './components/pc_label.vue'
export default {
  data () {
    return {
      pageNum: 1,
      totalItems: 0,
      itemsPerPage: 20,
      groupId: 0,
      classes: [],
      labels: [],
      list: []
    }
  },
  components: {
    cell,
    PcClass,
    PcLabel
  },
  mounted() {
    this.getClass()
    this.getLabel(1) // Tab 默认选中 ”备孕“
    this.getList()
  },
  methods: {
    gotoVideo (id = 1) {
      this.$router.push({ path: `/course/video/more/${ id }` })
    },
    getLabel (parent) {
      let that = this
      let params = {
        parent: parent
      }
      getLabelList(params).then(res => {
        that.labels = res
        // that.getList()
      })
    },
    getClass () {
      let that = this
      let params = {
        parent: 0
      }
      getLabelList(params).then(res => {
        that.classes = res
        // that.getList()
      })
    },
    getList () {
      let params = {
        type: 'text',
        pageNum: this.pageNum,
        pageRow: this.itemsPerPage,
      }
      if (this.groupId) {
        params.id = this.groupId
      }
      getArticleList(params).then(res => {
        this.list = res.data
        this.totalItems = res.totalRecords
      })
    },
    clickLabel (id) {
      this.groupId = id
      this.getList()
    },
    clickClass (id) {
      this.groupId = id
      this.getList()
    },
    clickTab (id) {
      this.getLabel(id)
    },
    pageChanged (pageNum) {
      this.pageNum = pageNum
      this.getList()
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 10px 0;
  .content {
    .con-left {
      height: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
    }
    .con-right {
      .class {
        border-radius: 4px;
        border: 0.5px solid #F2F2F2;
      }
      .label {
        margin: 12px 0;
        border-radius: 4px;
        border: 0.5px solid #F2F2F2;
      }
    }
  }
}
</style>